import {isFeatureEnabled} from '@github-ui/feature-flags'
import {SingleSignOnBanner} from '@github-ui/single-sign-on-banner'
import {useMemo} from 'react'

// eslint-disable-next-line no-restricted-imports
import {useChatState} from '../utils/CopilotChatContext'
import {ChatWithCopilotHeader} from './ChatWithCopilotHeader'
import {COPILOT_CHAT_MENU_PORTAL_ROOT} from './PortalContainerUtils'
import TopicList from './TopicList'
import styles from './TopicPicker.module.css'

export const TopicPicker = () => {
  const state = useChatState()

  const ssoOrgNames = useMemo(() => {
    if (!state.ssoOrganizations) return []
    return state.ssoOrganizations.map(org => org.login)
  }, [state.ssoOrganizations])

  return (
    <div className={styles.TopicPickerContainer}>
      <div className={styles.mainContentContainer}>
        <ChatWithCopilotHeader mode={state.mode} />
        <div className={styles.topicListContainer}>
          <TopicList />
        </div>
        {!isFeatureEnabled('global_sso_banner') && (
          <SingleSignOnBanner
            portalContainerName={COPILOT_CHAT_MENU_PORTAL_ROOT}
            protectedOrgs={ssoOrgNames}
            redirectURI={() => `/search/refresh_blackbird_caches?return_to=${location.href}`}
            className={styles.SingleSignOnBanner}
          />
        )}
      </div>
    </div>
  )
}

try{ TopicPicker.displayName ||= 'TopicPicker' } catch {}